import { useEffect, useState } from "react";
import emailjs from "emailjs-com";
import "./Estimation.css";

const EMAILJS_SERVICE_ID = "service_d5ju7td";
const EMAILJS_PUBLIC_KEY = "3DuqRUkxLl2usJwy1";
const TEAM_TEMPLATE_ID = "template_j7urv1v"; // shared template used by Consultation form too

const generatePDF = ({
  leadData,
  selectedPackage,
  packages,
  items,
  total,
  onSuccess,
}) => {
  const packageName = packages[selectedPackage]?.name ?? "";
  const now = new Date();
  const dateStr = now.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });

  const rows = items
    .map(
      (item) => `
      <tr>
        <td>${item.label}</td>
        <td>${item.value.toLocaleString("en-IN")}</td>
        <td>${item.units}</td>
        <td>₹${item.amount.toLocaleString("en-IN")}</td>
        <td class="amt">₹${item.totalCost.toLocaleString("en-IN")}</td>
      </tr>`,
    )
    .join("");

  const html = `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8" />
<title>Construction Estimate – Sarrathi Constructions</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap');
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body {
    font-family: 'Inter', system-ui, sans-serif;
    color: #102447;
    background: #fff;
    padding: 48px 52px;
    font-size: 13px;
  }
  .header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-bottom: 28px;
    border-bottom: 3px solid #102447;
    margin-bottom: 32px;
  }
  .logo-row {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }
  .logo-icon-wrap {
    width: 64px;
    height: 64px;
    flex-shrink: 0;
    overflow: hidden;
    background: #fff;
    position: relative;
  }
  .company-logo {
    display: block;
    position: absolute;
    /* The source logo file has ~20-25% empty space above the artwork, so
       cropping requires actually moving the image up (not just scaling in
       place, which only grows it downward and leaves the top whitespace
       untouched). We enlarge the image past the box, then shift it up and
       left so the whitespace band scrolls above the visible window and
       gets clipped by overflow:hidden, while the enlarged bottom/sides
       still fully cover the box (no empty gap).
       TUNING: if the icon is still a bit low, make "top" more negative
       (e.g. -24px, -28px). If too much is now cropped/icon too big,
       reduce width/height back toward 64px and top/left toward 0. */
    width: 84px;
    height: 84px;
    top: -6px;
    left: -10px;
    object-fit: cover;
  }
  .logo-block {
    margin-top: 4px; /* compensates for the font's ascender gap so the top of "S" lines up with the top of the logo */
  }
  .logo-block .company {
    font-size: 26px;
    font-weight: 900;
    letter-spacing: -0.5px;
    color: #102447;
    line-height: 1;
  }
  .logo-block .sub-brand {
    position: relative;
    display: inline-block;
    margin-top: 4px;
    padding-bottom: 7px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1.8px;
    text-transform: uppercase;
    color: #102447;
  }
  .logo-block .sub-brand::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 48px;
    height: 2px;
    border-radius: 2px;
    background: linear-gradient(90deg, #f97316, #fbbf24);
  }
  .logo-block .tagline {
    font-size: 11px;
    font-weight: 600;
    color: #f97316;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-top: 8px;
  }
  .logo-block .address {
    font-size: 11px;
    font-weight: 500;
    color: #6b7a99;
    line-height: 1.5;
    margin-top: 8px;
    max-width: 260px;
  }
  .meta { text-align: right; }
  .meta .doc-title {
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #6b7a99;
    margin-bottom: 4px;
  }
  .meta .doc-date { font-size: 13px; font-weight: 700; color: #102447; }
  .pkg-badge {
    display: inline-block;
    padding: 4px 14px;
    border-radius: 999px;
    background: #fbbf24;
    color: #102447;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin-bottom: 32px; }
  .info-box { padding: 18px 20px; border-radius: 10px; background: #f7f9fc; border: 1px solid #e2e8f0; }
  .info-box h4 {
    font-size: 9px; font-weight: 900; letter-spacing: 2px;
    text-transform: uppercase; color: #6b7a99; margin-bottom: 10px;
  }
  .info-box p { font-size: 13px; font-weight: 700; color: #102447; line-height: 1.7; }
  .info-box p span { font-weight: 400; color: #5a6887; }
  table { width: 100%; border-collapse: collapse; margin-bottom: 24px; }
  thead tr { background: #102447; color: #fff; }
  thead th {
    padding: 12px 14px; font-size: 10px; font-weight: 900;
    letter-spacing: 1.5px; text-transform: uppercase; text-align: left;
  }
  tbody tr:nth-child(even) { background: #f7f9fc; }
  tbody td { padding: 13px 14px; font-size: 13px; font-weight: 600; color: #102447; border-bottom: 1px solid #e2e8f0; }
  td.amt { font-weight: 900; }
  .total-bar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 20px 24px; border-radius: 10px; background: #102447; color: #fff; margin-bottom: 36px;
  }
  .total-bar .label { font-size: 11px; font-weight: 900; letter-spacing: 2px; text-transform: uppercase; }
  .total-bar .amount { font-size: 28px; font-weight: 900; color: #fbbf24; }
  .terms-block {
    margin-top: 12px;
    margin-bottom: 28px;
    padding: 20px 24px;
    border-radius: 10px;
    background: #f7f9fc;
    border: 1px solid #e2e8f0;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .terms-block h4 {
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 2px;
    text-transform: uppercase;
    color: #102447;
    margin-bottom: 12px;
  }
  .terms-block ul { margin: 0; padding-left: 18px; list-style: disc; }
  .terms-block li {
    font-size: 12px;
    color: #5a6887;
    line-height: 1.7;
    margin-bottom: 6px;
  }
  .terms-block li:last-child { margin-bottom: 0; }
  .footer {
    border-top: 1px solid #e2e8f0; padding-top: 18px; display: flex; justify-content: space-between; align-items: flex-end;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .footer p { font-size: 11px; color: #6b7a99; line-height: 1.6; }
  .footer .note { font-size: 10px; color: #9aa3b5; text-align: left; max-width: 260px; }
  table, tr, thead, .total-bar { page-break-inside: avoid; break-inside: avoid; }
  @media print { body { padding: 36px 44px; } @page { margin: 0; size: A4; } }
</style>
</head>
<body>
  <div class="header">
    <div class="logo-row">
      <div class="logo-icon-wrap">
        <img
          class="company-logo"
          src="/logo/company%20logo.jpeg"
          alt="Sarrathi Constructions logo"
        />
      </div>
      <div class="logo-block">
        <div class="company">Sarrathi Constructions</div>
        <div class="sub-brand">Art of Construction</div>
        <div class="tagline">Passion · Precision · Quality</div>
        <div class="address">82, Jagannathan Salai, Anjugam Nagar, SRP Colony, Kolathur, Chennai - 600082.</div>
      </div>
    </div>
    <div class="meta">
      <div class="doc-title">Construction Estimate</div>
      <div class="doc-date">${dateStr}</div>
    </div>
  </div>

  <div class="pkg-badge">${packageName} Package</div>

  <div class="info-grid">
    <div class="info-box">
      <h4>Prepared For</h4>
      <p>${leadData.name}<br/><span>${leadData.email}</span><br/><span>${leadData.phone}</span></p>
    </div>
    <div class="info-box">
      <h4>Prepared By</h4>
      <p>Sarrathi Constructions<br/><span>build@sarrathiconstructions.com</span><br/><span>+91 9840524873<br/>+91 9840798059</span></p>
    </div>
  </div>

  <table>
    <thead>
      <tr><th>Item</th><th>Value</th><th>Units</th><th>Rate (₹)</th><th>Total (₹)</th></tr>
    </thead>
    <tbody>${rows}</tbody>
  </table>

  <div class="total-bar">
    <span class="label">Total Estimated Cost</span>
    <span class="amount">₹${total.toLocaleString("en-IN")}</span>
  </div>

  <div class="terms-block">
    <h4>Terms &amp; Conditions</h4>
    <ul>
      <li>Electrical power and water required for construction shall be provided by the client.</li>
      <li>All government approvals, statutory charges, taxes, and utility connection fees shall be borne by the client.</li>
      <li>Advance payment shall be made by the client before the commencement of work.</li>
      <li>Any additional or deviation work requested by the client shall be charged separately.</li>
      <li>The quotation is valid for 15 days from the date of issue, unless otherwise specified.</li>
    </ul>
  </div>

  <div class="footer">
    <p>&nbsp &nbsp&nbspSarrathi Constructions &nbsp;<br/> Passion · Precision · Quality</p>
    <p class="note">* Estimates are indicative and subject to site inspection.<br/>* Final quote may vary based on design and material choices.</p>
    
  </div>
</body>
</html>`;

  const iframe = document.createElement("iframe");
  iframe.style.cssText =
    "position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:0;";
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(html);
  iframeDoc.close();

  let cleaned = false;
  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;
    if (document.body.contains(iframe)) document.body.removeChild(iframe);
  };

  // Browsers deliberately don't tell us whether the person clicked "Save"
  // or "Cancel" in the print/save dialog — there's no reliable signal for
  // that. What we CAN detect is when the dialog closes, via `afterprint`.
  // We treat that as "done" (not "successfully saved") and clean up then,
  // instead of assuming success on a fixed timer regardless of what the
  // person actually did.
  iframe.contentWindow.addEventListener("afterprint", () => {
    if (onSuccess) onSuccess();
    cleanup();
  });

  // Wait for the logo image to actually finish loading (or fail) before
  // opening the print dialog, so the PDF doesn't get printed with a blank
  // logo slot on slower machines/connections. Falls back to a fixed delay
  // if the image never fires load/error for some reason.
  const triggerPrint = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
    // Fallback cleanup in case `afterprint` never fires in some browsers.
    setTimeout(cleanup, 60000);
  };

  const logoImg = iframeDoc.querySelector(".company-logo");
  if (logoImg && !logoImg.complete) {
    let fired = false;
    const fireOnce = () => {
      if (fired) return;
      fired = true;
      setTimeout(triggerPrint, 200);
    };
    logoImg.addEventListener("load", fireOnce);
    logoImg.addEventListener("error", fireOnce);
    // Safety net in case neither load nor error fires.
    setTimeout(fireOnce, 3000);
  } else {
    setTimeout(triggerPrint, 700);
  }
};

const Estimation = () => {
  const [selectedPackage, setSelectedPackage] = useState("standard");
  const [formData, setFormData] = useState({
    area: "",
    overheadTank: "",
    undergroundSump: "",
    compoundWall: "",
  });

  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showEmptyWarning, setShowEmptyWarning] = useState(false);
  const [leadData, setLeadData] = useState({
    name: "",
    email: "",
    phone: "",
    source: "",
  });
  const [leadErrors, setLeadErrors] = useState({});
  const [pendingDownload, setPendingDownload] = useState(false);

  const packages = {
    basic: { name: "Basic", price: 2150 },
    standard: { name: "Standard", price: 2300 },
    premium: { name: "Premium", price: 2600 },
  };

  const rates = { overheadTank: 27, undergroundSump: 27, compoundWall: 2200 };

  const sourceOptions = [
    "Google Search",
    "Instagram",
    "Facebook",
    "WhatsApp",
    "Friend / Family Referral",
    "Site Visit / Hoarding",
    "Other",
  ];

  const handlePackageSelect = (packageType) => setSelectedPackage(packageType);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value === "" ? "" : parseFloat(value) || 0,
    }));
  };

  const handleClear = () => {
    setFormData({
      area: "",
      overheadTank: "",
      undergroundSump: "",
      compoundWall: "",
    });
    setSelectedPackage("standard");
  };

  const handleLeadInputChange = (e) => {
    const { name, value } = e.target;
    setLeadData((prev) => ({ ...prev, [name]: value }));
    setLeadErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateLead = () => {
    const errors = {};
    if (!leadData.name.trim()) errors.name = "Please enter your name";
    if (!leadData.email.trim()) {
      errors.email = "Please enter your email";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(leadData.email)) {
      errors.email = "Enter a valid email address";
    }
    if (!leadData.phone.trim()) {
      errors.phone = "Please enter your phone number";
    } else if (!/^[0-9+\s-]{7,15}$/.test(leadData.phone)) {
      errors.phone = "Enter a valid phone number";
    }
    if (!leadData.source)
      errors.source = "Please tell us how you heard about us";
    return errors;
  };

  const calculateCosts = () => {
    if (!selectedPackage) return { items: [], total: 0 };
    const packagePrice = packages[selectedPackage].price;
    const items = [
      {
        label: "Built-up Area",
        value: formData.area || 0,
        units: "SQFT",
        amount: packagePrice,
        totalCost: (formData.area || 0) * packagePrice,
      },
      {
        label: "Overhead Tank",
        value: formData.overheadTank || 0,
        units: "LITRES",
        amount: rates.overheadTank,
        totalCost: (formData.overheadTank || 0) * rates.overheadTank,
      },
      {
        label: "Underground Sump",
        value: formData.undergroundSump || 0,
        units: "LITRES",
        amount: rates.undergroundSump,
        totalCost: (formData.undergroundSump || 0) * rates.undergroundSump,
      },
      {
        label: "Compound Wall",
        value: formData.compoundWall || 0,
        units: "RFT",
        amount: rates.compoundWall,
        totalCost: (formData.compoundWall || 0) * rates.compoundWall,
      },
    ];
    const total = items.reduce((sum, item) => sum + item.totalCost, 0);
    return { items, total };
  };

  const handleDownloadClick = () => {
    const { total } = calculateCosts();
    if (total <= 0) {
      setShowEmptyWarning(true);
      setTimeout(() => setShowEmptyWarning(false), 4000);
      return;
    }
    setPendingDownload(true);
    setIsLeadModalOpen(true);
  };

  // Notify the team by email with the lead's details + estimate breakdown.
  // This does NOT attach the actual PDF (EmailJS free plan doesn't support
  // attachments, and the PDF here is generated via the browser print dialog
  // rather than as a capturable file) — it sends the underlying data instead,
  // using the same shared template as the consultation popup.
  const sendLeadNotification = ({ items, total }) => {
    const breakdownRows = items
      .map(
        (item, i) => `
      <tr${i % 2 === 1 ? ' style="background-color: #f7f7f7;"' : ""}>
        <td style="padding: 7px 10px; font-size: 13px;">${item.label}</td>
        <td style="padding: 7px 10px; font-size: 13px;">${item.value.toLocaleString("en-IN")} ${item.units}</td>
        <td style="padding: 7px 10px; font-size: 13px;">₹${item.amount.toLocaleString("en-IN")}</td>
        <td style="padding: 7px 10px; font-size: 13px; font-weight: bold; text-align: right;">₹${item.totalCost.toLocaleString("en-IN")}</td>
      </tr>`,
      )
      .join("");

    const extraDetails = `
      <div style="margin-top: 20px;">
        <div style="font-size: 13px; font-weight: bold; color: #1a3c6e; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 10px;">Cost Breakdown</div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #e0e0e0; border-radius: 4px;">
          <thead>
            <tr style="background-color: #1a3c6e;">
              <th style="padding: 8px 10px; text-align: left; color: #ffffff; font-size: 12px;">Item</th>
              <th style="padding: 8px 10px; text-align: left; color: #ffffff; font-size: 12px;">Value</th>
              <th style="padding: 8px 10px; text-align: left; color: #ffffff; font-size: 12px;">Rate</th>
              <th style="padding: 8px 10px; text-align: right; color: #ffffff; font-size: 12px;">Amount</th>
            </tr>
          </thead>
          <tbody>${breakdownRows}</tbody>
        </table>
        <div style="margin-top: 14px; padding: 12px 16px; background-color: #1a3c6e; border-radius: 6px; display: flex; justify-content: space-between; align-items: center;">
          <span style="color: #ffffff; font-size: 13px; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px;">Total Estimate</span>
          <span style="color: #fbbf24; font-size: 18px; font-weight: bold;">₹${total.toLocaleString("en-IN")}</span>
        </div>
      </div>`;

    emailjs
      .send(
        EMAILJS_SERVICE_ID,
        TEAM_TEMPLATE_ID,
        {
          request_type: "New Estimation Request",
          from_name: leadData.name,
          from_email: leadData.email,
          phone: leadData.phone,
          field1_label: "Package",
          field1_value: `${packages[selectedPackage]?.name ?? ""} Package`,
          field2_label: "Heard About Us Via",
          field2_value: leadData.source || "Not specified",
          field3_label: "Built-up Area",
          field3_value: `${formData.area || 0} sqft`,
          extra_details: extraDetails,
        },
        EMAILJS_PUBLIC_KEY,
      )
      .catch((err) => console.error("EmailJS estimation lead error:", err));
  };

  const handleLeadSubmit = (e) => {
    e.preventDefault();
    const errors = validateLead();
    if (Object.keys(errors).length > 0) {
      setLeadErrors(errors);
      return;
    }
    setIsLeadModalOpen(false);
    if (pendingDownload) {
      setPendingDownload(false);
      const { items, total } = calculateCosts();
      sendLeadNotification({ items, total });
      generatePDF({
        leadData,
        selectedPackage,
        packages,
        items,
        total,
        onSuccess: handleDownloadSuccess,
      });
    }
  };

  const handleDownloadSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 4000);
  };

  const closeLeadModal = () => {
    setIsLeadModalOpen(false);
    setPendingDownload(false);
  };

  useEffect(() => {
    document.body.style.overflow = isLeadModalOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isLeadModalOpen]);

  const { items, total } = calculateCosts();

  return (
    <div className="estimation-container">
      <div className="estimation-heading">
        <p className="section-eyebrow">Estimation</p>
        <h2>Calculate your construction price</h2>
        <p>
          Select a package and enter your project details to get an approximate
          construction estimate.
        </p>
      </div>

      <div className="estimate-locked-area">
        <div className="estimate-package-selection">
          <h3>Select your package</h3>
          <div className="estimate-package-cards">
            {Object.entries(packages).map(([key, pkg]) => (
              <button
                type="button"
                key={key}
                className={`estimate-package-card ${selectedPackage === key ? "selected" : ""}`}
                onClick={() => handlePackageSelect(key)}
              >
                <span>{pkg.name}</span>
                <strong>₹{pkg.price}/sqft</strong>
              </button>
            ))}
          </div>
        </div>

        <div className="estimate-main-content">
          <div className="estimate-form-card">
            <h3>Project details</h3>
            <label>
              Enter your area
              <input
                type="number"
                name="area"
                value={formData.area}
                onChange={handleInputChange}
                placeholder="Area in square feet"
              />
            </label>
            <label>
              Overhead tank
              <input
                type="number"
                name="overheadTank"
                value={formData.overheadTank}
                onChange={handleInputChange}
                placeholder="Capacity in litres"
              />
            </label>
            <label>
              Underground sump
              <input
                type="number"
                name="undergroundSump"
                value={formData.undergroundSump}
                onChange={handleInputChange}
                placeholder="Capacity in litres"
              />
            </label>
            <label>
              Compound wall
              <input
                type="number"
                name="compoundWall"
                value={formData.compoundWall}
                onChange={handleInputChange}
                placeholder="Length in running feet"
              />
            </label>
            <button
              type="button"
              className="estimate-clear-btn"
              onClick={handleClear}
            >
              ↺ Clear &amp; Start Fresh
            </button>
          </div>

          <div className="estimate-result-card">
            <h3>Cost breakdown</h3>
            <div className="estimate-table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Value</th>
                    <th>Units</th>
                    <th>Rate</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr>
                      <td colSpan="5" className="empty-estimate">
                        Select a package to view your estimate.
                      </td>
                    </tr>
                  ) : (
                    items.map((item) => (
                      <tr key={item.label}>
                        <td>{item.label}</td>
                        <td>{item.value}</td>
                        <td>{item.units}</td>
                        <td>₹{item.amount.toLocaleString()}</td>
                        <td>₹{item.totalCost.toLocaleString()}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
            <div className="total-estimation">
              <span>Total estimation</span>
              <strong>₹{total.toLocaleString()}</strong>
            </div>
            <button
              type="button"
              className={`estimate-download-btn ${!selectedPackage ? "is-disabled" : ""}`}
              disabled={!selectedPackage}
              onClick={handleDownloadClick}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              Download Your Estimation
            </button>
          </div>
        </div>
      </div>

      {showSuccess && (
        <div
          className="download-success-toast"
          role="status"
          aria-live="polite"
        >
          <div className="dst-icon-wrap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.8"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <div className="dst-text">
            <strong>Your Estimation PDF is Ready</strong>
            <span>
              If the save dialog closed without saving, click Download again.
            </span>
          </div>
        </div>
      )}

      {showEmptyWarning && (
        <div
          className="download-warning-toast"
          role="status"
          aria-live="polite"
        >
          <div className="dwt-icon-wrap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.6"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <line x1="12" y1="9" x2="12" y2="13.5" />
              <circle
                cx="12"
                cy="16.75"
                r="0.75"
                fill="currentColor"
                stroke="none"
              />
              <path d="M10.29 3.86 1.82 18a1.5 1.5 0 0 0 1.29 2.25h17.78A1.5 1.5 0 0 0 22.18 18L13.71 3.86a1.5 1.5 0 0 0-2.42 0Z" />
            </svg>
          </div>
          <div className="dst-text">
            <strong>Enter your project details first</strong>
            <span>
              Fill in the area or other fields to see your estimation before
              downloading.
            </span>
          </div>
        </div>
      )}

      {isLeadModalOpen && (
        <div className="lead-modal-backdrop" onClick={closeLeadModal}>
          <div
            className="lead-modal-card"
            role="dialog"
            aria-modal="true"
            aria-label="Get your free estimation"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="lead-modal-close"
              onClick={closeLeadModal}
              aria-label="Close"
            >
              ×
            </button>
            <p className="section-eyebrow lead-modal-eyebrow">
              Free Estimation
            </p>
            <h3 className="lead-modal-title">Tell us a bit about you</h3>
            <p className="lead-modal-subtext">
              We'll prepare your PDF instantly — no calls, no spam.
            </p>
            <form
              className="lead-modal-form"
              onSubmit={handleLeadSubmit}
              noValidate
            >
              <label>
                Full name
                <input
                  type="text"
                  name="name"
                  value={leadData.name}
                  onChange={handleLeadInputChange}
                  placeholder="Your name"
                  autoComplete="name"
                />
                {leadErrors.name && (
                  <span className="lead-error">{leadErrors.name}</span>
                )}
              </label>
              <label>
                Email address
                <input
                  type="email"
                  name="email"
                  value={leadData.email}
                  onChange={handleLeadInputChange}
                  placeholder="you@example.com"
                  autoComplete="email"
                />
                {leadErrors.email && (
                  <span className="lead-error">{leadErrors.email}</span>
                )}
              </label>
              <label>
                Phone number
                <input
                  type="tel"
                  name="phone"
                  value={leadData.phone}
                  onChange={handleLeadInputChange}
                  placeholder="+91 98765 43210"
                  autoComplete="tel"
                />
                {leadErrors.phone && (
                  <span className="lead-error">{leadErrors.phone}</span>
                )}
              </label>
              <label>
                How did you hear about us?
                <select
                  name="source"
                  value={leadData.source}
                  onChange={handleLeadInputChange}
                >
                  <option value="">Select an option</option>
                  {sourceOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                {leadErrors.source && (
                  <span className="lead-error">{leadErrors.source}</span>
                )}
              </label>
              <button type="submit" className="lead-modal-submit">
                Download My Estimation
              </button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Estimation;
